<!--
 * @Author: xuquantong
 * @Date: 2022-04-26 19:34:27
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-07-11 16:13:45
 * @Description: 价格模块
-->
<template>
  <div
    class="price-info"
    :class="[discountType, mergePriceAndTitle ? 'price-info-merge' : '']"
    :style="priceAreaBg"
    v-track="{
      act: 'show',
      params: {
        cfrom: '236|001|02|077',
        event_id: '236|001|02|077',
        ...commonTrackData
      }
    }"
  >
    <!-- 价格 -->
    <div class="price">
      <div
        v-track="{
          act: 'click',
          params: {
            cfrom: '236|001|01|077',
            event_id: '236|001|01|077',
            ...commonTrackData
          }
        }"
      >
        <PriceModule></PriceModule>
      </div>
      <logo-item v-if="isShowPromotion"></logo-item>
    </div>
    <!-- 优惠券列表 -->
    <div
      class="discount"
      tabindex="0"
      :class="{ discount2: !commodityEstimated }"
      v-if="discountLabels.length !== 0"
      @click="showDiscountPopup"
      v-track="{
        act: 'click',
        params: {
          cfrom: '236|001|01|077',
          event_id: '236|001|01|077',
          ...commonTrackData
        }
      }"
    >
      <div class="left">
        <CouponLabel v-for="(v, i) in discountLabels" :text="v.discountDescribe" :key="i"></CouponLabel>
      </div>
      <div class="coupon" :class="labelTheme" v-if="!onlyPoint">
        <span>{{ rightText }}</span>
        <svg width="12" height="20" viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg" class="right-arrow">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L7.63636 9.76924L0 20H4.36364L12 9.76924L4.36364 0H0Z" />
        </svg>
      </div>
    </div>
    <ProductInfo v-if="mergePriceAndTitle"></ProductInfo>
  </div>
</template>

<script>
import PriceModule from '../price-module'
import ProductInfo from '../product-info'
import logoItem from './logo-item'
import CouponLabel from './coupon-label'
import { mapGetters, mapActions, mapState } from 'vuex'

const bgImgs = {}
;['deposit', 'group', 'group-tag', 'quickbuy', 'vip'].forEach(item => {
  // 大促图片使用后台配置
  bgImgs[item] = require(`./imgs/bg-${item}.png`)
})
export default {
  name: 'PriceInfo',
  components: { PriceModule, logoItem, ProductInfo, CouponLabel },
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', [
      'discountType',
      'isShowPromotion',
      'mergePriceAndTitle',
      'skuId',
      'commodityEstimated',
      'pointInfo',
      'isDepositBuy'
    ]),
    discountLabels() {
      let discountLabels = (this.skuInfo?.commoditySkuDiscount?.discountLabels || []).filter(
        v => v.discountLabelType !== '3'
      )
      if (this.pointInfo.supportFlag) {
        if (this.pointInfo.pointsMoney) {
          if (this.isDepositBuy) {
            discountLabels.push({
              discountDescribe: `尾款阶段积分最多可抵${this.pointInfo.pointsMoney}元`,
              discountLabelType: '3'
            })
          } else {
            discountLabels.push({
              discountDescribe:
                discountLabels.length === 0
                  ? `积分当钱花，积分最多可抵${this.pointInfo.pointsMoney}元`
                  : `积分最多可抵${this.pointInfo.pointsMoney}元`,
              discountLabelType: '3'
            })
          }
        } else {
          discountLabels.push({
            discountDescribe: discountLabels.length === 0 ? `积分当钱花，当前商品支持积分抵现` : '支持积分抵现',
            discountLabelType: '3'
          })
        }
      }
      return discountLabels
    },
    commonTrackData() {
      const price_type = isNaN(this.commodityEstimated?.priceLabelType) ? -1 : this.commodityEstimated?.priceLabelType
      const button = this.discountLabels.length === 0 ? '' : this.rightText
      const sku_id = this.skuId
      const page_name = 1
      // 接口返回 // 1 单品满减，2 到手价计算券，3 积分抵现 4 订单满减 5 升级可领券
      // 埋点设计 // 1:积分抵现;2:优惠券;3:单品满减;4:订单满减
      const type = Array.from(new Set(this.discountLabels.map(v => v.discountLabelType))).join('')
      return {
        price_type,
        button,
        sku_id,
        page_name,
        type
      }
    },
    labelTheme() {
      // vip,group,deposit,fullpay,quickbuy,bigpromotion,normal,quickbuypreheat
      switch (this.discountType) {
        case 'vip':
          return 'black'
        case 'fullpay':
        case 'deposit':
          return 'purple'
        case 'normal':
        case 'quickbuypreheat':
        case 'quickbuynoatmos':
          return 'white'
        default:
          return 'red'
      }
    },
    // 如果没有优惠券显示优惠，有的话就显示领券
    rightText() {
      return this.discountLabels.some(v => v.discountLabelType === 3) ? '领券' : '优惠'
    },
    // true: 优惠外显只有一个积分标签
    onlyPoint() {
      return this.discountLabels.length == 1 && this.discountLabels[0].discountLabelType == '3'
    },
    priceAreaBg() {
      let bgType = ''
      if (['deposit', 'quickbuy', 'vip'].includes(this.discountType)) {
        bgType = this.discountType
      } else if (this.discountType === 'group') {
        bgType = this.discountLabels.length == 0 ? 'group' : 'group-tag'
      } else if (this.discountType === 'fullpay') {
        bgType = 'deposit'
      }
      return bgType != '' && this.isShowPromotion && { backgroundImage: `url(${bgImgs[bgType]})` }
    }
  },
  methods: {
    ...mapActions('detailv3', [
      'changeDiscountPopupStatus',
      'changePointDescriptionPopupStatus',
      'savePreFocusElByEvent'
    ]),
    showDiscountPopup(e) {
      if (this.onlyPoint) {
        this.changePointDescriptionPopupStatus(true)
        this.$track({
          cfrom: '237|004|01|077',
          event_id: '237|004|01|077',
          ...this.commonTrackData
        })
      } else {
        this.changeDiscountPopupStatus(true)
        this.$track({
          cfrom: '237|003|02|077',
          event_id: '237|003|02|077',
          ...this.commonTrackData
        })
      }
      this.savePreFocusElByEvent(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.price-info {
  padding: 46px 36px 36px 36px;
  border-radius: 0px 0px 36px 36px;
  background-size: 100%;
  margin-top: -1px;
  position: relative;
  z-index: 2;
  &-merge {
    padding: 48px 36px 0 36px;
  }
  &.group {
    background-size: 100% 100%;
  }
  .price {
    display: flex;
    justify-content: space-between;
  }

  .discount {
    &.discount2 {
      margin-top: 6px;
    }
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      position: relative;
      width: 806px;
      overflow-x: scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      white-space: nowrap;

      ::v-deep .coupon-label {
        margin-left: 18px;
        margin-top: 6px;

        &:first-child {
          margin-left: 0;
        }
      }
      ::v-deep .coupon-container {
        margin-left: 18px;
        margin-top: 6px;
        &:first-child {
          margin-left: 0;
        }
      }
    }

    .coupon {
      font-size: 30px;
      position: relative;
      border-radius: 180px;
      width: 132px;
      height: 70px;
      padding-top: 3px;
      border: 2.5px solid #f10313;
      display: flex;
      justify-content: center;
      align-items: center;
      @include bgColor(rgba(255, 255, 255, 0.2), transparent);
      box-sizing: border-box;
      .right-arrow {
        margin-top: -2px;
        width: 12px;
        height: 20px;
        margin-left: 5px;
      }

      &.white {
        border: 2.5px solid #f10313;
        color: #f10313;
        @include os-font-weight(30, 40);
        fill: #f10313 !important;
      }

      &.black {
        border: 2.5px solid #ffc121;
        color: #ffc121;
        @include os-font-weight(30, 40);
        background: rgba(255, 193, 33, 0.2);
        fill: #ffc121 !important;
      }

      &.red,
      &.purple {
        border: 2.5px solid rgba(255, 255, 255, 0.7);
        @include fontColor(#ffffff, rgba(255, 255, 255, 0.9));
        @include os-font-weight(30, 40);
        fill: #fff !important;
      }
    }
  }

  ::v-deep .product-info-wrap {
    padding: 48px 0 0 0 !important;
    margin: 0;
  }
}

.is-vertical,
.is-horizontal {
  .price-info {
    .discount {
      .left {
        width: 1400px !important;
      }
    }
  }
}
</style>
